import React, { useEffect, useRef, useState } from "react";
import styles from "./style/investstyle.module.css";
import { ReactComponent as WhiteLogo } from "../../svg/logo/sunbae/whitelogo.svg";
import { ReactComponent as Logo } from "../../svg/newlogo.svg";
import { ReactComponent as RightChevron } from "../../svg/chevron-right-light-gray.svg";
import { ReactComponent as Plus } from "../../svg/plus-sharp-solid.svg";
import { ReactComponent as ChevronDown } from "../../svg/tabler_chevron-down.svg";
import { ReactComponent as ChevronUp } from "../../svg/tabler_chevron-up.svg";
import { Checkbox, List, ListItem, Modal, ModalDialog, Sheet } from "@mui/joy";
import NumberAnimation from "../../control/numberanimation";

import { ReactComponent as DaeguFour } from "../../svg/daegufour2.svg";
import { ReactComponent as GangnamFour } from "../../svg/gangnamfour2.svg";
import { ReactComponent as SongpaFour } from "../../svg/songpafour2.svg";
import { ReactComponent as SpeechBubble } from "../../svg/speech11bubble.svg";

import { ReactComponent as InvestFolder } from "../../svg/investfolder2.svg";
import { ReactComponent as InvestTemp } from "../../svg/investtemp2.svg";
import { ReactComponent as InvestWifi } from "../../svg/investwifi2.svg";


import { stagger, style } from "motion";
import Footer from "../../components/footer";
import { CircularProgress } from "@mui/material";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { inView, animate } from "motion";
import { useMediaQuery } from "react-responsive";

import { Link, useNavigate } from "react-router-dom";

const whySub = [
    {
        blueText : "수능선배에 투자하면 얼마를 버나요?",
        title : "62% 수익률",
        subText : "수능선배는 50%~62%의 수익률을 보여줘요",
        subSubText : "관리형 독서실 평균 수익률 30%~40%",
        // imgSrc : "https://static.toss.im/3d/won-jump-up-2s-apng.png"
        imgSrc : "/img/studycafes/investrocketnew.webp"
    },
    {
        blueText : "수능선배는 리스크 보장을 해주나요?",
        title : "본사 책임으로\n리스크 보장",
        subText : "최소 수익률 35% 미달 시 타 지점 수익금 추가 배분해 드려요",
        subSubText : "안전한 투자 환경을 제공해드려요",
        // imgSrc : "https://static.toss.im/3d/moneybag-rotate-apng.png"
        imgSrc : "/img/studycafes/investrisknew.webp"
    },
    {
        blueText : "수능선배 운영을 제가 신경써야하나요?",
        title : "운영스트레스 ZERO\n본사가 A 부터 Z",
        subText : "운영을 어떻게 할지 걱정마세요!",
        subSubText : "본사가 설계부터 운영까지 모든 것을 관리해요",
        // imgSrc : "https://static.toss.im/3d/free-sparkle-envelope-apng.png"
        imgSrc : "/img/studycafes/investzeronew.webp"
    }
]

const waitingNumber = [
    {
        number: 500,
        text: "수능선배 대치점 대기자",
        subText: "대치동 최고 대기자 수",
        imgSrc: "img/daechiinterior/J2V_2053.webp"
    },
    {
        number: 300,
        text: "수능선배 강남점 대기자",
        subText: "퇴원률 1%대 유지",
        imgSrc: "img/newinterior/02BL7589_1.webp"
    },
    {
        number: 300,
        text: "수능선배 강남2호점 대기자",
        subText: "오픈 전 사전 마감",
        imgSrc: "img/daechiinterior/J2V_2134.webp"
    },
    {
        number: 200,
        text: "수능선배 분당점 대기자",
        subText: "분당 최대규모 독학재수학원",
        imgSrc: "img/newinterior/bundang/_J2V5293.webp"
    },
    {
        number: 150,
        text: "수능선배 송파점 대기자",
        subText: "퇴원률 1%대 유지",
        imgSrc: "img/newinterior/241228_062.webp"
    },
    {
        number: 150,
        text: "수능선배 대구점 대기자",
        subText: "오픈 첫날 전석 마감",
        imgSrc: "img/newinterior/241228_036.webp"
    }
]

const endingStory = [
    {
        title: `대구점 156석\n설명회 당일 마감`,
        // img: "https://framerusercontent.com/images/dPHaS37gcAXgI3Gg3ATxdlQZw.webp"
        img : "/img/studycafes/investclock.webp"
    },
    {
        title: `강남점 142석\n오픈 전 사전 마감`,
        // img: "https://static.toss.im/3d/toss-ad-keyvisual-character-only-apng.png"
        img : "/img/studycafes/investchair.webp"
    }
]

const onlyFourLocations = [
    {
        title: "송파점",
        text: "최상의 쾌적한 시설\n맞춤 설계",
        // img : "https://static.toss.im/3d-emojis/u1F4C8-blue-cylinder.png"
        img: <InvestTemp className={styles.onlyFourLocationsImg} />
    },
    {
        title: "대구점",
        text: "초대형 자습실\n맞춤 설계",
        img: <InvestFolder className={styles.onlyFourLocationsImg} />
    },
    {
        title: "강남점",
        text: "IOT 자동화 설비\n맞춤 설계",
        img: <InvestWifi className={styles.onlyFourLocationsImg} />
    }
]

const systems: any = [
    {
        title: "쾌적함을 위해 설계된\n학습 공간 인테리어",
        text: "전 지점 높은 층고와 넓은 책상, 적정용량\n2배 이상의 환기설비와\n자동 창문 개폐기가 설치되어 있어요.",
        imgSrc: "img/daechiinterior/J2V_2053.webp",
        //20프로 확대
        style: {

        },
        link : "https://suneungsunbae.com/storyread?id=131"
    },
    {
        title: "50대 1 면접을 통과한\n초호화 멘토진",
        text: "초호화 멘토진에게\n수능선배의 노하우를 교육 후\n학생 개인 맞춤 상담을 진행하고 있어요.",
        imgSrc: "img/newinterior/02BL7844_1.webp",
        style: {
            transform: "scale(1.4)"
        },
        link : "https://suneungsunbae.com/storyread?id=32"
    },
    {
        title: "자체 개발한 빈틈없는\n출결 관리 프로그램",
        text: "수능선배가 직접 개발한\n출결 관리 프로그램을 통해 1분 단위\n외출까지 빈틈없이 관리하고 있어요.",
        imgSrc: "img/newinterior/241228_014.webp",
        style: {},
        link : "https://suneungsunbae.com/storyread?id=197"
    },
    {
        title: "예약된 시간에 개폐되는\n자동 창문 시스템",
        text: "학원 내 모든 창문이 예약된 시간에\n자동으로 개폐되어\n쾌적한 학습 환경을 유지할 수 있어요.",
        imgSrc: "img/newinterior/bundang/_J2V5372.webp",
        //20프로 확대, 오른쪽으로 20% 이동
        style: {
            transform: "scale(1.2)"
        },
        link : "https://suneungsunbae.com/storyread?id=131"
    },
    {
        title: "수능선배 전용\n어플리케이션",
        text: "자체 개발한 어플리케이션 안에\n독학재수학원의 모든 시스템을 적용시켜놔서\n학생들이 편리하게 이용할 수 있어요.",
        imgSrc: "img/applicationimg.webp",
        style: {
            width: "50%",
            objectFit: "contain",
            transform: "translateX(-10%)"
        },
        link : "https://suneungsunbae.com/storyread?id=273"
    }
]


const managingList = [
    {
        title : "본사에서 신규 지점 위치 선정",
        text : "본사에서 시행하는 수요 조사 결과를 바탕으로 가장 운영이 잘 될 수 있는 위치를 선정합니다.",
        imgSrc : "img/studycafes/investlocation.webp"
    },
    {
        title : "지점 설립비용 지분 투자",
        text : "지점 설립에 필요한 비용을 투자자들이 원하는 지분에 맞게 나눠서 투자합니다.",
        imgSrc : "img/studycafes/investshare.webp"
    },
    {
        title : "본사에서 설계, 인테리어, 운영까지 전부 관리",
        text : "투자자들은 운영에 대한 스트레스 없이 본사에서 모든 것을 A부터 Z까지 관리합니다.",
        imgSrc : "img/studycafes/investsparkle.webp"
    },
    {
        title : "투자금 회수",
        text : "첫 수익부터 최우선으로 투자금 회수가 가능합니다.",
        imgSrc : "img/studycafes/investreturn.webp"
    },
    {
        title : "5:5 배분",
        text : "운영으로 발생하는 수익은 투자자와 본사가 5:5로 배분합니다.",
        imgSrc : "img/studycafes/investhalf.webp"
    },
    {
        title : "리스크 보장",
        text : "최소 수익률 35% 미달 시 타 지점 수익금 추가 배분해 드려요.",
        imgSrc : "img/studycafes/investrisk.webp"
    }
]

const managingListMobile = [
    {
        title : "본사에서 위치선정",
        text : "본사의 조사 결과를 바탕으로\n운영이 잘 될 수 있는 위치 선정",
        imgSrc : "img/studycafes/investlocation.webp"
    },
    {
        title : "지분 투자",
        text : "지점 설립 비용을 투자자들이\n원하는 지분에 맞게 나눠 투자",
        imgSrc : "img/studycafes/investshare.webp"
    },
    {
        title : "본사에서 ALL",
        text : "투자자는 운영 스트레스 ZERO\n본사가 A부터 Z까지 관리",
        imgSrc : "img/studycafes/investsparkle.webp"
    },
    {
        title : "투자금 회수",
        text : "첫 수익부터 최우선으로\n투자금 회수 가능",
        imgSrc : "img/studycafes/investreturn.webp"
    },
    {
        title : "5:5 배분",
        text : "운영으로 발생하는 수익은\n투자자와 본사가 5:5로 배분",
        imgSrc : "img/studycafes/investhalf.webp"
    },
    {
        title : "리스크 보장",
        text : "최소 수익률 35% 미달 시 타 지점 수익금 추가 배분해 드려요",
        imgSrc : "img/studycafes/investrisk.webp"
    }
];

const faq = [
    {
        question : "리스크 보장은 어떤식으로 해주나요?",
        answer : "최소 수익률 35% 미달 시 본사 직영으로 운영하는 타지점 수익금을 추가로 배분해 드립니다."
    },
    // {
    //     question : "은행이자 3%는 뭘까요?",
    //     answer : "원금 뿐만 아니라 은행에 예금 했을 경우 받으실 수 있었던 이자 3%까지 보장해 드리는 것입니다."
    // },
    {
        question : "운영을 제가 할 수는 없나요?",
        answer : "수능선배는 전 지점의 운영상의 퀄리티를 유지하기 위해 본사에서 모든 관리를 하고 있어서 직접 운영은 불가능합니다."
    },
    {
        question : "금액은 상관없이 투자 가능한가요?",
        answer : "투자 금액은 최소 5천만원부터 가능하며, 투자 금액에 따라 지분율이 달라집니다."
    },
    {
        question : "오픈 소요기간은 얼마나 걸리나요?",
        answer : "투자 확정 후 약 3개월에서 5개월 사이에 오픈이 가능합니다."
    },
    {
        question : "투자자가 해야할 일은 없나요?",
        answer : "수능선배에서 운영에 관한 모든 것을 책임지기 때문에 별도의 업무는 없습니다. 투자자님은 투자금 회수와 수익 배분만 받으시면 됩니다."
    },
    {
        question : "왜 최소 수익률을 보장하나요?",
        answer : "수능선배는 수요가 확실한 지역에만 지점을 오픈하기 때문에 최소 수익률을 보장해 드릴 수 있습니다."
    }
]

const InvestMainPage: React.FC = () => {

    const [name, setName] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    const [open, setOpen] = useState<boolean>(false);
    const footerRef = useRef<HTMLDivElement | null>(null);
    const [isFooterVisible, setIsFooterVisible] = useState<boolean>(false);

    const [firstDivRefAnimation, setFirstDivRefAnimation] = useState<HTMLDivElement | null>(null);

    const isLowerThan1024 = useMediaQuery({ query: '(max-width: 1024px)' });
    const navigate = useNavigate();

    const [openedIndex, setOpenedIndex] = useState<number>(-1);

        useEffect(() => {
    
            window.scrollTo(0, 0);
    
        }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    setIsFooterVisible(entry.isIntersecting);
                });
            },
            {
                root: null,      // viewport
                threshold: 0.18,    // footer가 한 픽셀이라도 보이면 true
            }
        );

        if (footerRef.current) observer.observe(footerRef.current);

        return () => observer.disconnect();
    }, []);

    const handleClose = () => {
        setOpen(false);
    };


    const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        let digits = e.target.value.replace(/[^0-9]/g, "");

        // 2. 최대 11자리(010-1234-5678)로 제한
        if (digits.length > 11) digits = digits.slice(0, 11);

        // 3. 자리 수에 맞춰 하이픈 삽입
        let formatted = digits;
        if (digits.length > 3 && digits.length <= 7) {
            formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`; // 010-1234
        } else if (digits.length > 7) {
            formatted = `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`; // 010-1234-5678
        }

        setPhoneNumber(formatted);

    }

    const submit = async () => {

        try{
            if(!name.trim()){
                notify2();
                return;
            }

            if(!phoneNumber.trim()){
                notify3();
                return;
            }

            setLoading(true);

            // 여기에 API 호출 로직 추가
            // 예시: await api.submitForm({ name, phoneNumber });
            const response: any = await fetch("https://peetsunbae.com/dashboard/report/registerinvest", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: name,
                    phoneNumber: phoneNumber
                })
            });

            const result = await response.json();

            console.log(result);

            if (result.message === "success") {

                // 성공적으로 제출 후 초기화
                setName("");
                setPhoneNumber("");
                setLoading(false);

                notify1(); // 성공 알림

            }




        }catch(e){
            console.error("Error submitting form:", e);
            // 에러 처리 로직 추가
        }

    }

    const notify1 = () => toast.success("상담 신청 성공!", {
        position: "bottom-right",
        autoClose: 3500,
        hideProgressBar: true,
        theme: "colored"
    });



    const notify2 = () => toast.warning("이름을 적어주세요", {
        position: "bottom-right",
        autoClose: 3500,
        hideProgressBar: true,
        theme: "colored"
    });

    const notify3 = () => toast.warning("휴대폰 번호를 적어주세요", {
        position: "bottom-right",
        autoClose: 3500,
        hideProgressBar: true,
        theme: "colored"
    });

    useEffect(() => {


        inView("#firstMainDivAnimtaion", ({ target }) => {
            animate(target, {
                opacity: 1,
                transform: "translateY(0px)"
            }, {
                duration: 0.2,
                delay: 0.2,
                easing: "ease-in"
            })
        })

        inView("#moveUpDivAnimation", ({ target }) => {
            animate(target, {
                transform: "translateY(0px)"
            }, {
                duration: 0.55,
                delay: 0,
                easing: "ease-out"
            })
        });

        inView("#moveUpDivAnimationStagger1", ({ target }) => {
            animate(target, {
                transform: "translateY(0px)"
            }, {
                duration: 0.55,
                delay: 0.1,
                easing: "ease-out"
            })
        });

        inView("#moveUpDivAnimationStagger2", ({ target }) => {
            animate(target, {
                transform: "translateY(0px)"
            }, {
                duration: 0.55,
                delay: !isLowerThan1024 ? 0.2 : 0.1,
                easing: "ease-out"
            })
        });

        inView("#moveUpDivAnimationStagger3", ({ target }) => {
            animate(target, {
                transform: "translateY(0px)"
            }, {
                duration: 0.55,
                delay: !isLowerThan1024 ? 0.3 : 0.1,
                easing: "ease-out"
            })
        });

        inView("#moveUpDivAnimationStagger4", ({ target }) => {
            animate(target, {
                transform: "translateY(0px)"
            }, {
                duration: 0.55,
                delay: !isLowerThan1024 ? 0.4 : 0.1,
                easing: "ease-out"
            })
        });

    }, [isLowerThan1024]);

    return (
        <div className={styles.investMainPage}>
            <div className={styles.firstComponent}>
                <div className={styles.inner}>
                    <div className={styles.header}>
                        <div onClick={() => navigate("/")}
                            style={{
                                cursor: "pointer",
                            }}
                            >
                            <WhiteLogo className={styles.logo} />
                        </div>
                        <div>
                            <div className={styles.blueBtn}
                            //클릭 시 https://suneungsunbae.com/로 이동
                                onClick={() => {
                                    window.open("https://suneungsunbae.com/", "_blank");
                                }}
                            >
                                수능선배 홈페이지
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.innerMainDiv} ${styles.firstMainDivAnimation}`} id="firstMainDivAnimtaion" style={{

                    }}>
                        <div>
                            <div className={styles.mainTitle}>
                                지점 오픈 예상 비용과<br />수익금을 알려드려요
                            </div>
                            <div className={styles.mainSubTitle}>
                                수능선배에 대해서 <br className={styles.onlyMobile} />자세히 알아본 후 신청 부탁드립니다.
                            </div>
                            <div className={styles.mainImg}>
                                <img
                                    // src="https://static.toss.im/3d/customer-service-area-apng.png"
                                    src="/img/studycafes/investfacenew.webp"
                                    alt="Customer service area"
                                    style={{
                                        objectFit: 'contain',
                                        transform: 'scale(1)',
                                        width: "240px",
                                        height: "240px"
                                    }}
                                />
                            </div>
                        </div>
                        <div className={styles.innerMainDiv2}>
                            <div style={{
                                width: "100%"
                            }}>
                                <div className={styles.inputText}>
                                    <span style={{
                                        position: "relative",
                                    }}>
                                        이름
                                        <div className={styles.inputTextDot}>
                                        </div>
                                    </span>
                                </div>
                                <div className={styles.inputDiv}>
                                    <input
                                        type="text"
                                        placeholder="이름"
                                        className={styles.input}
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div style={{
                                width: "100%",
                                marginTop: "20px"
                            }}>
                                <div className={styles.inputText}>
                                    <span style={{
                                        position: "relative",
                                    }}>
                                        휴대폰 번호
                                        <div className={styles.inputTextDot}>
                                        </div>
                                    </span>
                                </div>
                                <div className={styles.inputDiv}>
                                    <input
                                        type="text"
                                        inputMode="numeric"     // 모바일 키패드 숫자 전용
                                        pattern="[0-9]*"        // 숫자만 허용
                                        placeholder="010-••••-••••"
                                        className={styles.input}
                                        value={phoneNumber}
                                        onChange={handlePhoneNumberChange}
                                        maxLength={13}          // 010-1234-5678 => 13글자
                                    />
                                </div>
                            </div>
                            <div
                                className={styles.privacyText}
                                onClick={() => {
                                    setOpen(true);
                                }}
                            >
                                <div>
                                    개인정보수집 동의(상담 및 안내에만 사용되어요)
                                </div>
                                <div>
                                    <RightChevron
                                        fill="rgb(229,232,235)"
                                        className={styles.rightChevron} />
                                </div>
                            </div>
                            <div style={{
                                width: "100%",
                            }}
                                className={styles.submitBtn}
                                onClick={submit}
                            >
                                {
                                    loading
                                        ?
                                        <CircularProgress
                                        color="inherit"
                                        />
                                        :
                                        "동의하고 상담받기"
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.subComponent}>
                <div className={styles.inner2}>
                    <div className={`${styles.subTitle} ${styles.subTitleLeft}`}
                    >
                        왜,<br />수능선배여야 할까요?
                    </div>
                    <div className={styles.whySubSubTitle}>
                        대치동 1등 독학재수학원 수능선배
                    </div>
                    <div className={`${styles.whySubDiv}`}>
                                {
                                    whySub.map((item, index) => (
                                        <div className={`${styles.whySubItem} ${styles.moveUpDivAnimation}`}
                                        key={index} id="moveUpDivAnimation"
                                        >
                                            <div className={styles.whySubTextDiv}>
                                                <div className={styles.whySubBlueTextSpan}>
                                                    {item.blueText}
                                                </div>
                                                <div className={styles.whySubTitle}>
                                                    {item.title}
                                                </div>
                                                <div className={styles.whySubText}>
                                                    {item.subText}
                                                </div>
                                                <div className={styles.whySubSubText}>
                                                    {item.subSubText}
                                                </div>
                                            </div>
                                            <div className={`${styles.whySubImgDiv} ${index === 0 ? styles.whySubImgDiv1 : index === 2 ? styles.whySubImgDiv2 : ""}`}>
                                                {
                                                    item.imgSrc.includes(".mp4")
                                                        ?
                                                        <video
                                                            autoPlay
                                                            loop
                                                            muted
                                                            className={styles.whySubImg}
                                                        >
                                                            <source src={item.imgSrc} type="video/mp4" />
                                                        </video>
                                                        :
                                                        <img src={item.imgSrc} className={`${styles.whySubImg} ${index === 0 ? styles.whySubImg1 : ""} 
                                                        ${index === 2 ? styles.whySubImg2 : ""}`} alt={item.title}
                                                         />
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                    </div>
                    <div className={`${styles.justHeight1} ${styles.onlyPc}`}></div>
                    <div className={`${styles.onlyMobile}`}
                    style={{
                        height : "10px"
                    }}
                    ></div>
                </div>
            </div>

            <div className={styles.subComponent}
            style={{
                backgroundColor : "#F9FAFB"
            }}
            >
                <div className={styles.inner2}>
                    <div className={`${styles.subTitle} ${styles.moveUpDivAnimation}`}
                        id="moveUpDivAnimation"
                    >
                        압도적 대기자, <br className={styles.onlyMobile} />수능선배와 함께
                    </div>
                    <div className={`${styles.smallSubTitle} ${styles.moveUpDivAnimation}`}
                    id="moveUpDivAnimation"
                    >
                        (2025년 3분기 기준 전 지점 전석 마감)
                    </div>
                    <div className={styles.gridGallery1}>
                        {
                            waitingNumber.map((item, index) => {
                                return (
                                    <div
                                        className={`${styles.waitingNumberDiv} 
                                        ${styles.moveUpDivAnimation}
                                        `}
                                        style={{
                                            //  '--bg-url': `url(${item.imgSrc})` 
                                            backgroundImage: `url(${item.imgSrc})`,
                                            } as React.CSSProperties
                                        }
                                        key={index}
                                        id="moveUpDivAnimation"
                                    >
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                            className={styles.galleryNumberDiv}
                                        >
                                            <div>
                                                {/* {item.number} */}
                                                <NumberAnimation number={item.number} fixed={0} delay={400} />
                                            </div>
                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                                className={styles.plusIconDiv}
                                            >
                                                +
                                            </div>

                                        </div>
                                        <div
                                            className={styles.galleryTextDiv}>
                                            {item.text}
                                        </div>
                                        <div
                                            className={styles.gallerySubTextDiv}
                                        >
                                            ({item.subText})
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={styles.justHeight1}>

                    </div>
                </div>
            </div>

            <div className={styles.subComponent} style={{
                backgroundColor: "#E8F3FF"
            }}>
                <div className={styles.inner2}>
                    <div
                    id="moveUpDivAnimation"
                    className={styles.moveUpDivAnimation}
                    >
                        <div className={`${styles.subTitle}`}
                        >
                            수능선배, <br className={styles.onlyMobile} />오픈 동시 전석 마감
                        </div>
                        <div className={styles.smallSubTitle}>
                            (2025년 오픈 지점)
                        </div>

                    </div>
                   
                    <div className={styles.gridGallery1}>
                        {
                            endingStory.map((item, index) => {
                                return (
                                    <div className={`${styles.endingStoryDiv} ${styles.moveUpDivAnimation}`} key={index}
                                    id="moveUpDivAnimation"
                                    
                                    >
                                        <div className={styles.endingStoryTitle}>
                                            {item.title}
                                        </div>
                                        <div className={styles.endingStoryImgDiv}>
                                            <img
                                                src={item.img}
                                                alt={item.title}
                                                //index1일때 2일때 className를 다르게 주기
                                                className={`${styles.endingStoryImg} ${index === 1 ? styles.endingStoryImg2 : ""}`}
                                            />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={styles.justHeight1}>

                    </div>

                </div>
            </div>

            <div className={styles.subComponent}>
                <div className={styles.inner2}>
                    {
                        !isLowerThan1024
                            ?
                            <div className={`${styles.subTitle} ${styles.moveUpDivAnimation}`}
                                id="moveUpDivAnimation"
                            >
                                모든 시스템은 <br className={styles.onlyMobile} />독학재수학원에<br />최적화 되게 만들기 위해<br />수능선배가 직접 개발하고 <br className={styles.onlyMobile} />적용시킵니다
                            </div>
                            :
                            <div className={`${styles.subTitle} ${styles.moveUpDivAnimation}`}
                                id="moveUpDivAnimation"
                            >
                                독학재수학원 맞춤형<br />시스템을 수능선배가 직접<br />개발하고 적용시킵니다
                            </div>
                    }
                    
                    <div className={`${styles.subComponentCenterImgDiv} ${styles.moveUpDivAnimation}`}
                    id="moveUpDivAnimation"
                    >
                        <img
                            // src="https://static.toss.im/3d/shield-plate-security-apng.png"
                            src="/img/studycafes/wifinew.webp"
                            alt="Shield plate security"
                            className={styles.subComponentCenterImg}
                        />
                    </div>
                    <div className={styles.moveUpDivAnimation}
                    id="moveUpDivAnimation"
                    >
                        <div className={`${styles.subComponentSmallText}`}
                        >
                            수능선배의 시스템은 독학재수학원 운영 <br className={styles.onlyMobile} />9년간의 노하우에 더불어<br />모든 개발 역량을 본사가 직접 가지고 있어<br />독학재수학원에 최적화된 시스템만을 설계합니다.
                        </div>
                        <div className={`${styles.subComponentMoreSmallText}`}
                        >
                            ※ 수능선배 수강료 750,000~780,000 원/월
                        </div>
                    </div>
                    <div className={styles.justHeight1}>
                    </div>
                </div>
            </div>

            <div className={styles.subComponent} style={{
                backgroundColor: "rgb(25, 31, 40)"
            }}>
                <div className={styles.inner3}>
                    <div className={styles.moveUpDivAnimation}
                        id="moveUpDivAnimation"
                    >
                        <div className={styles.subTitle} style={{
                            color: "white"
                        }}>
                            맞춤설계하기 때문에<br />수능선배는 1년에 4개의 <br className={styles.onlyMobile} />지점만 오픈합니다
                        </div>
                        <div className={styles.smallSubTitle} style={{
                            color: "white",
                        }}>
                            (2025년 오픈 지점)
                        </div>
                    </div>

                    <div className={styles.gridGallery3}>
                        {
                            onlyFourLocations.map((item, index) => {
                                return (
                                    <div className={`${styles.onlyFourLocationsDiv} ${styles.moveUpDivAnimationStagger}`} key={index}
                                    id={`moveUpDivAnimationStagger${index + 1}`}
                                    >
                                        <div className={styles.onlyFourLocationsTitle}>
                                            {item.title}
                                        </div>
                                        <div className={styles.onlyFourLocationsImgDiv}>
                                            {item.img}
                                        </div>
                                        <div className={styles.onlyFourLocationsText}>
                                            {item.text}
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className={`${styles.onlyFourLocationsDiv2} ${styles.moveUpDivAnimationStagger}`} style={{
                            color: "white"
                        }}
                        id="moveUpDivAnimationStagger4"
                        >
                            <div className={styles.onlyFourLocationsTitle2}>
                                2025년<br />마지막<br />투자자
                            </div>
                            <div className={styles.onlyFourLocationsText2}>
                                모집중
                            </div>
                            <div className={styles.onlyFourLocationsText3}>
                                *2025년 마지막 지점<br />투자자 모집 OPEN
                            </div>
                        </div>
                    </div>

                </div>

                <div className={styles.justHeight1}>

                </div>
            </div>

            <div className={styles.subComponent} style={{
                backgroundColor: "#f9fafb"
            }}>
                <div className={styles.inner3}>
                    <div className={`${styles.subTitle} ${styles.moveUpDivAnimation}`}
                    id="moveUpDivAnimation"
                    >
                        전국 독학재수학원 중<br />대기자 수 최대, <br className={styles.onlyMobile} />연평균 공석률 최저인 이유
                    </div>
                    <div className={styles.systemGridDiv}>
                        {
                            systems.map((item: any, index: number) => {
                                return (
                                    <div key={index} className={`${styles.systemDiv} ${index % 2 === 0 ? styles.systemDivLeft : styles.systemDivRight} ${styles.moveUpDivAnimation}`}
                                    id="moveUpDivAnimation"
                                    >
                                        <div className={styles.systemImg} style={index === 4 ? {
                                            display: "flex",
                                            justifyContent: "center",
                                        } : {}}>
                                            <img
                                                src={item.imgSrc}
                                                alt={item.title}
                                                className={`${styles.systemImgItem} ${index === 4 ? styles.systemImgItem2 : ""}`}
                                                style={item.style} // Apply the style from the item
                                            />
                                        </div>
                                        <div className={styles.systemTextDiv}>
                                            <div className={styles.systemTitle}>
                                                {item.title}
                                            </div>
                                            <div className={styles.systemText}>
                                                {item.text}
                                            </div>
                                            <div className={`${styles.systemMoreBtn} ${styles.onlyPcFlex}`}
                                                onClick={() => {
                                                    window.open(item.link, "_blank");
                                                }}
                                            >
                                                자세히 보기
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>



                <div className={styles.justHeight1}>

                </div>
            </div>

            <div className={styles.subComponent}>
                <div className={styles.inner2}>
                    <div className={`${styles.subTitle} ${styles.moveUpDivAnimation} ${styles.subTitleExceptMargin}`}
                    id="moveUpDivAnimation"
                    >
                        본사에서 A부터 Z 까지<br />운영 스트레스 ZERO
                    </div>
                    <div className={`${styles.subTitleText2} ${styles.moveUpDivAnimation} ${styles.subTitleExceptMargin2}`}
                    id="moveUpDivAnimation"
                    >
                        운영 스트레스 없이 본사에서<br />직접 모든 관리를 맡아서 해줘요
                    </div>
                    <div className={styles.managingListDiv}>
                        {
                            !isLowerThan1024
                            ?
                            managingList.map((item, index) => {
                                return (
                                    <div className={`${styles.managingListItem} ${styles.moveUpDivAnimation}`} key={index}
                                    id="moveUpDivAnimation"
                                    >
                                        <div className={styles.managingListIndex}>
                                            <div className={styles.managingListIndexText}>
                                                {index + 1}
                                            </div>
                                        </div>
                                        <div className={`${styles.managingListImgDiv} ${styles.managingListImgDivForPc}`}>
                                            <img src={item.imgSrc} alt={`Managing List ${index + 1}`}
                                            className={styles[`managingListImg${index + 1}`]}
                                            />
                                        </div>  
                                        <div className={styles.managingListTextDiv}>
                                            <div className={styles.managingListTitle}>
                                                {item.title}
                                            </div>
                                            <div className={styles.managingListText}>
                                                {item.text}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            :
                            managingListMobile.map((item, index) => {
                                return (
                                    <div className={`${styles.managingListItem} ${styles.moveUpDivAnimation}`} key={index}
                                    id="moveUpDivAnimation"
                                    >
                                        <div style={{
                                            display : "flex",
                                            height: "100%",
                                        }}>
                                        <div className={styles.managingListIndex}>
                                            <div className={styles.managingListIndexText}>
                                                {index + 1}
                                            </div>
                                        </div>
                                        <div className={styles.managingListTextDiv} style={{
                                            display: "flex",
                                            flexDirection : "column",
                                            justifyContent: "center",
                                        }}>
                                            <div className={styles.managingListTitle}>
                                                {item.title}
                                            </div>
                                            <div className={styles.managingListText}>
                                                {item.text}
                                            </div>
                                        </div>
                                        </div>
                                        <div className={styles.managingListImgDiv}>
                                            <img src={item.imgSrc} alt={`Managing List ${index + 1}`} />
                                        </div>  
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <div className={`${styles.subTitle2} ${styles.moveUpDivAnimation}`}
                    id="moveUpDivAnimation"
                >
                    수능선배 학생의 <br className={styles.onlyMobile} />하루를 담았습니다
                </div>

                <div className={`${styles.videoBox} ${styles.moveUpDivAnimation}`}
                id="moveUpDivAnimation"
                >
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://www.youtube.com/embed/L8OAOPAoO0M?si=Hb4QvtfGjjXbm8mb&controls=1&rel=0&modestbranding=1&loop=1&playsinline=1&color=white"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                    />
                </div>

                <div className={`${styles.subTitle2} ${styles.moveUpDivAnimation}`}
                    id="moveUpDivAnimation"
                >
                    자주 묻는 질문
                </div>
                <div className={styles.inner2}>
                    <div className={styles.faqDiv}>
                        {
                            faq.map((item, index) => (
                                <div className={`${styles.faqItem} ${styles.moveUpDivAnimation}`} key={index} onClick={() => {
                                            setOpenedIndex(openedIndex === index ? -1 : index);
                                        }}
                                        id = "moveUpDivAnimation"
                                        >
                                    <div className={styles.faqTitle}>
                                        <div className={styles.faqTitleText}>
                                            Q. {item.question}
                                        </div>
                                        <div className={`${styles.faqTitleIcon} ${openedIndex === index ? styles.active : ''}`}>
                                            {
                                                openedIndex === index
                                                    ? <ChevronUp className={styles.faqTitleIconImg} />
                                                    : <ChevronDown className={styles.faqTitleIconImg} />
                                            }
                                        </div>
                                    </div>
                                    <div className={`${styles.faqContent} ${openedIndex === index ? styles.active : ''}`}>
                                        {item.answer}
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className={styles.onlyMobile}
                style={{
                    height : "50px"
                }}
                ></div>

                <div className={styles.justHeight1}>

                </div>
            </div>
                        
            <div ref={footerRef}
            >
                <Footer />
            </div>


            <div className={styles.fixedDiv} style={{
                display: isFooterVisible ? "none" : "block",
            }}>
                <div className={styles.fixedDivInner}>
                    <div className={styles.fixedDivInner1}>
                        <div className={styles.fixedDivLogo}>
                            <Logo className={styles.fixedDivLogoImg} />
                        </div>
                        <div className={styles.verticalLine}></div>
                        <div className={`${styles.fixedDivText} ${styles.onlyPc}`}>
                            궁금한점이 있다면<br />본사 담당자와 상담해보세요
                        </div>
                    </div>
                    <div className={styles.fixedDivInner2}>
                        <div className={styles.fixedDivBtn1} onClick={(e : any) => {
                            //맨 위로 스크롤
                            e.preventDefault();
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth"
                            });
                        }}>
                            상담 신청하기
                        </div>
                        <div className={styles.fixedDivBtn2} onClick={(e : any) => {
                            //링크 열기
                            e.preventDefault();
                            window.open("http://pf.kakao.com/_Whxexgxj/chat", "_blank");
                        }}>
                            <SpeechBubble className={styles.fixedDivBtn2Img} />
                        </div>
                    </div>
                </div>
            </div>


            <Modal
                open={open}
                onClose={handleClose}
                sx={{
                    backdropFilter: "blur(0px)",
                }}
            >
                <ModalDialog sx={{
                    borderRadius: "10px",
                    overflowY: "auto",
                    minWidth: "250px"
                }}>
                    <div style={{
                        width: "100%",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        fontSize: "11px"
                    }}>
                        <span style={{
                            fontWeight: 500
                        }}>[개인정보 수집 및 마케팅 정보 수신 동의]<br></br><br></br></span>
                        수능선배는 신청자 관리를 위해 개인정보를 수집·이용하며,
                        입시 정보, 이벤트, 할인 행사, 신규 모집, 투자 정보 등 다양한 소식을 제공하기 위해 마케팅 정보 수신에 대한 동의를 요청합니다.<br></br><br></br>

                        - 수집 항목: 이름, 연락처 등 수능선배 마케팅 활용 관련 개인 정보<br></br>
                        - 수집 및 이용 목적: 투자 설명회 신청 및 관리, 프로그램·이벤트 안내, 입시 정보 제공, 서비스 개선<br></br>
                        - 보유 및 이용 기간: 수집일로부터 동의 철회 시까지<br></br>
                        - 유의사항: 개인정보 제공 및 마케팅 수신 동의는 거부하실 수 있으나, 이 경우 투자 설명회 신청 및 관련 혜택 제공이 제한될 수 있습니다.<br></br>
                        - 철회 안내: 동의 후에도 언제든지 마케팅 수신을 거부하거나 개인정보 삭제를 요청하실 수 있습니다.<br></br>

                    </div>
                </ModalDialog>
            </Modal>


           <Modal
    open={true}
    onClose={() => {}}
    sx={{
        backdropFilter: "blur(2px)",
    }}
>
    <ModalDialog
        sx={{
            borderRadius: "12px",
            overflowY: "auto",
            minWidth: "300px",
            maxWidth: "400px",
            padding: "24px"
        }}
    >
        <div
            style={{
                width: "100%",
                fontSize: "15.5px",   // 🔥 전체 글씨 키움
                lineHeight: "1.7",
                color: "#333"
            }}
        >
            <div
                style={{
                    fontWeight: 700,
                    fontSize: "18px",   // 🔥 제목 크게
                    marginBottom: "14px"
                }}
            >
                [2026년 상반기 투자 마감]
            </div>

            <div style={{ marginBottom: "14px" }}>
                2026년 상반기 수능선배에 대한 많은 투자와 관심 감사합니다.
            </div>

            <div style={{ marginBottom: "14px" }}>
                투자 유치를 일시 중지하고, 현재 운영 중인 지점의 안정적인 관리와
                서비스 품질 향상에 집중하고자 합니다.
            </div>

            <div
                style={{
                    marginBottom: "14px",
                    fontWeight: 600,
                    fontSize: "16px"   // 🔥 강조 문장 더 크게
                }}
            >
                신규 투자 모집은 일시적으로 중단됩니다.
            </div>

            <div>
                더 나은 모습으로 다시 찾아뵙겠습니다. 감사합니다.
            </div>
        </div>
    </ModalDialog>
</Modal>

            <ToastContainer />
        </div>
    )
}

export default InvestMainPage;

